/**
 * @prettier
 * @flow
 */
export const KEY_NAME = 'apphook';

export function getApphookInLocaleStorage(): string {
    let item = window.localStorage.getItem('apphook');
    return JSON.parse(item) ?? '';
}
